var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dots-menu",
    transform: "translate(-114 -446)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 11,
    height: 11,
    transform: "translate(114 446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(118.03 446)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-0.03)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_30",
    "data-name": "Ellipse 30",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-0.03 4)",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_31",
    "data-name": "Ellipse 31",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-0.03 8)",
    fill: "#484848"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsMenu);
export default __webpack_public_path__ + "static/media/dots-menu.26460e502ce16a78bf8a8f2a4c90d9ae.svg";
export { ForwardRef as ReactComponent };